exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown .dropdown-menu[data-v-ba5a27d0]{width:350px}.dropdown .dropdown-menu .note[data-v-ba5a27d0]{overflow-y:auto;max-height:200px}", ""]);

// exports
